/*       */

import React, { useState, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Autocomplete } from '@mic3/platform-ui';
import { DOMParser } from '@xmldom/xmldom';

import ProcessTypeTypeahead from 'app/components/organisms/Form/Typeahead/ProcessTypeTypeahead';

const ProcessDefinitionKeysDefault = props => {
    const { disabled, processDefinitions, value, name, onChange } = props;

    const [selectedProcDef, setSelectedProcDef] = useState(value?.procDefId);

    const onChangeSelectedProcDef = useCallback(
        ({ target: { value: val } }) => {
            setSelectedProcDef(val);
            if (value?.value !== val) {
                onChange({ target: { name, value: null } });
            }
        },
        [setSelectedProcDef, onChange, value, name]
    );

    const keysOptions = useMemo(() => {
        if (!selectedProcDef) return [];

        const selectedDef = processDefinitions.find(procDef => procDef.id === selectedProcDef);

        let keys = [];
        if (selectedDef?.primary?.definition) {
            const doc = new DOMParser().parseFromString(selectedDef.primary.definition, 'xml/text');
            const userTasks = Array.from(doc.getElementsByTagName('userTask'));
            keys = userTasks.map(task => task.getAttribute('id'));
        }

        if (!keys?.length) return [];

        return keys.map(key => ({ value: key, label: key, procDefId: selectedProcDef }));
    }, [selectedProcDef, processDefinitions]);

    return (
        <div>
            <ProcessTypeTypeahead
                disabled={disabled}
                label={'Process definition'}
                name="processDefinition"
                value={selectedProcDef}
                onChange={onChangeSelectedProcDef}
            />
            <Autocomplete
                disabled={disabled || !keysOptions?.length}
                label={'Key'}
                options={keysOptions}
                value={value}
                clearable={false}
                name={name}
                onChange={props.onChange}
            />
        </div>
    );
};

const ProcessDefinitionKeys = ({ multiple, ...restProps }) => {
    return <ProcessDefinitionKeysDefault {...restProps} />;
};

export default connect(
    state => ({
        processDefinitions: state.abox.app.typeaheadProcessDefinitions.data?.records || [],
    }),
    {}
)(ProcessDefinitionKeys);
